export const CANVAS_WIDTH = 1024;
export const CANVAS_HEIGHT = 576;
export const TARGET_FPS = 60;
export const FRAME_TIME = 1000 / TARGET_FPS;

export const GROUND_Y = CANVAS_HEIGHT - 80;
export const GRAVITY = 0.6;

export const PLAYER_SPEED = 5;
export const JUMP_FORCE = -14;

export const ROUND_TIME_SECONDS = 99;
export const MAX_HEALTH = 100;
export const ROUNDS_TO_WIN = 2;

export const COLORS = {
  bg: '#1a0a2e',
  ground: '#2d1b00',
  groundLine: '#4a3000',
  healthBar: '#ff0000',
  healthBarBg: '#333333',
  healthBarBorder: '#ffffff',
  text: '#ffffff',
  title: '#ff4400',
  subtitle: '#ffaa00',
} as const;

export type FighterType = 'trex' | 'spinosaurus' | 'elon' | 'nikita';

export const FIGHTER_NAMES: Record<FighterType, string> = {
  trex: 'T-REX',
  spinosaurus: 'SPINOSAURUS',
  elon: 'ELON',
  nikita: 'NIKITA',
};
